import React from 'react';
import './SplitIntro.css';

const SplitIntro = () => {
  return (
    <section className="split-intro-section">
      <div className="split-container">
        <div className="split-left">
          <div className="split-text-large fade-in-up">
            <h2 className="split-title">
              The new<br />website<br />is here
            </h2>
          </div>
        </div>
        <div className="split-right">
          <div className="split-text-small fade-in-up">
            <p>
              Hey there, it was time for a well-deserved restyle. I'm currently
              curating new work and redesigning the layout to showcase both
              commercial and personal projects.
            </p>
            <p>
              In the meantime, feel free to explore the portfolio, discover new
              prints, or check out my{' '}
              <a href="https://instagram.com" className="text-link smooth-hover" target="_blank" rel="noopener noreferrer">
                Instagram
              </a>
              !
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SplitIntro;

